import { Dropdown, Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import navdots from '../../Assets/images/navdots.svg'
function AdminListActionsDropdown({admin,handleShowDeactivateModal, handleShowDeleteModal}){
return( 
    <>
     <div className="dropdown">
            <Dropdown>
              <Dropdown.Toggle variant="" className="btn btn-primary dropdown-toggle navbar-drop-buttons" id="dropdown-basic">
                <img src={navdots} alt="More actions" />
              </Dropdown.Toggle>

              <Dropdown.Menu className="el-action">
                {/* <Dropdown.Item as={Link} to={`admin-profile/${admin.id}`} state={{ admin }}>
                  View details
                </Dropdown.Item> */}
                  <Dropdown.Item as={Link} to={`admin-profile`} state={{ admin }}>
                  View details
                </Dropdown.Item>
                 <Dropdown.Item onClick={handleShowDeactivateModal}>

                  <label className={admin.active ? `text-danger` : `text-success`}>
                  {admin.active ? 'Deactivate' : 'Activate'}</label>
                </Dropdown.Item>
                <Dropdown.Item onClick={handleShowDeleteModal}>
                  Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
    </>
);


}


export default AdminListActionsDropdown;